

export const SalePurchaseParty = [
  {
    title: 'Sale & Purchase Party',
    path: '/SalePurchaseEntry'
  },
  {
    title: 'Sale & Purchase Party Register',
    path: '/SalePurchaseTable'
  }
]

export const Company = [
  {
    title: 'Firm Entry',
    path: '/FirmEntry'
  },
  {
    title: 'Firm Register',
    path: '/FirmTable'
  }
];

export const Items = [
  {
    title: 'Item Entry',
    path: '/ItemEntry'
  },
  {
    title: 'Item Register',
    path: '/ItemTable'
  },

];

export const Zones = [
  {
    title: 'Zone Entry',
    path: '/zone-entry'
  },
  {
    title: 'Zone Register',
    path: '/zone-register'
  },

];

export const StudenMenu = [
  {
    title: 'Student Entry',
    path: '/student-entry'
  },
  {
    title: 'Student Register',
    path: '/student-register'
  },
   {
    title: 'Whatsapp Send Msg',
    path: '/student-register-whatsapp'
  },

];

export const userMenu = [
  {
    title: 'User Register Entry',
    path: '/user-reg-entry'
  },
  {
    title: 'User Register',
    path: '/subuser-reg'
  },

];

export const LocationMenu = [
  {
    title: 'Location Entry',
    path: '/location-entry'
  },


];

export const Locations = [
  {
    title: 'School Entry',
    path: '/school-entry'
  },
  {
    title: 'School Register',
    path: '/school-register'
  },

];

export const StkInwMenu = [
  {
    title: 'Stock Inward Entry',
    path: '/stock-inward-entry'
  },
  {
    title: 'Stock Inward Register',
    path: '/stock-inward-register'
  },
  {
    title: 'Stock Details',
    path: '/stock-register'
  },
  {
    title: 'Stock Common Register',
    path: '/stock-common-register'
  },
  // {
  //   title: 'School Stock Inward Entry',
  //   path: '/user-stkinward-entry'
  // },
  {
    title: 'School Stock Inward Register',
    path: '/user-stkinward-register'
  },
  {
    title: 'School Stock Register',
    path: '/schl-stock-register'
  },
  {
    title: 'School Common Stock Register',
    path: '/school-common-stock'
  },
   {
    title: 'Transfer Stock Inward Entry',
    path: '/user-return-stock-inward-entry'
  },
  {
    title: 'Transfer Stock Inward Register',
    path: '/user-return-stock-inward-register'
  },
];

export const UStkInwMenu = [
  {
    title: 'Stock Inward Entry',
    path: '/user-stkinward-entry'
  },
  {
    title: 'Manual Stock Inward Entry',
    path: '/manual-school-inward'
  },
  {
    title: 'Stock Inward Register',
    path: '/user-stkinward-register'
  },
  {
    title: 'Stock Register',
    path: '/schl-stock-register'
  },
  // {
  //   title: 'Common Stock Register',
  //   path: '/school-common-stock'
  // },
];

export const adminStkInwMenu = [
  {
    title: 'Stock Inward Entry',
    path: '/stock-inward-entry'
  },
  {
    title: 'Stock Inward Register',
    path: '/stock-inward-register'
  },
  {
    title: 'Stock Details',
    path: '/stock-register'
  },
  {
    title: 'Stock Common Register',
    path: '/stock-common-register'
  }
];

export const AdminSaleMenu = [
  {
    title: 'Admin Sale Entry',
    path: '/admin-sale-entry'
  },
  {
    title: 'Admin Sale Register',
    path: '/admin-sale-register'
  },
  {
    title: 'Cancel Admin Sale Register',
    path: '/admin-sale-cancel-register'
  },
  {
    title: 'User Sale Entry',
    path: '/user-sale-entry'
  },
  {
    title: 'User Sale Register',
    path: '/user-sale-register'
  },
  {
    title: 'Admin Student Sale Entry',
    path: '/student-sale-entry'
  },
  {
    title: 'Admin Student Sale Register',
    path: '/student-sale-Register'
  },
  
];

export const UserSaleMenu = [
  {
    title: 'User Sale Entry',
    path: '/user-sale-entry'
  },
  {
    title: 'User Sale Register',
    path: '/user-sale-register'
  }
];


export const onlyAdminSaleMenu = [
  {
    title: 'Admin Sale Entry',
    path: '/admin-sale-entry'
  },
  {
    title: 'Admin Sale Register',
    path: '/admin-sale-register'
  },
  {
    title: 'Cancel Admin Sale Register',
    path: '/admin-sale-cancel-register'
  },
];

export const userReturnEntry=[
  {
    title: 'User Transfer Entry',
    path: '/user-return-entry' 
  },
  {
    title: 'User Transfer Register',
    path: '/user-return-reg' 
  },
]
export const adminSaleReport = [
  {
    title: 'Bill Wise Sale Report',
    path: '/admin-sale-report'
  },
  {
    title: 'Item Wise Sale Report',
    path: '/admin-item-report'
  },
  {
    title: 'User Sale Report',
    path: '/user-sale-report'
  }
];